import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    MoveDriveFolder,
    MoveDriveFile,

    setDriveAction,
    clearDriveSelection,
    reloadDriveLists,
} from "client/store"
import {
    Button,
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
    SpinnerIcon,
} from "client/components"
import { MtDriveFolder, MtDriveFile } from "server/models"


export const Restore = () => {
    const folderActive = useSelector((state: StoreType) => state.drive.folder.active)
    const foldersSelected = useSelector((state: StoreType) => state.drive.folder.selected)
    const fileActive = useSelector((state: StoreType) => state.drive.file.active)
    const filesSelected = useSelector((state: StoreType) => state.drive.file.selected)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [restoreState, setRestoreState] = useState<StateType>(IDLE)

    const onCancel = () => {
        dispatch(setDriveAction(null))
    }

    const onConfirm = () => {
        setRestoreState(PENDING)
        const folders = folderActive ? [folderActive] : foldersSelected
        const files = fileActive ? [fileActive] : filesSelected

        const promiseArray: Promise<any>[] = []

        folders.forEach((folder) => {
            const restoreFolder: MtDriveFolder = {
                ...folder,
                folderId: folder.prevFolderId || 0,
                prevFolderId: null,
            }
            promiseArray.push(MoveDriveFolder(restoreFolder))
        })

        files.forEach((file) => {
            const restoreFile: MtDriveFile = {
                ...file,
                folderId: file.prevFolderId || 0,
                prevFolderId: null,
            }
            promiseArray.push(MoveDriveFile(restoreFile))
        })

        Promise.all(promiseArray).then(() => {
            setRestoreState(IDLE)

            clearDriveSelection(dispatch)
            reloadDriveLists(dispatch)
        })
    }

    return (
        <ConfirmWrapper show onClose={onCancel}>
            <Confirm>
                <ConfirmTitle>{lang.confirmRestoreTitle}</ConfirmTitle>
                <ConfirmDescription>{lang.confirmRestoreDescription}</ConfirmDescription>
                <ConfirmBottom>
                    <Button variant="success" row onClick={onConfirm}>
                        {restoreState === PENDING ? <SpinnerIcon /> : lang.restore}
                    </Button>
                    <Button row onClick={onCancel}>
                        {lang.cancel}
                    </Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default Restore
